import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { greenwichConfig } from "./data";

export default function GreenwichPage() {
  return <CityPageTemplate config={greenwichConfig} />;
}